import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';

const ErrorAlert = ({ message }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-center space-x-3">
      <FiAlertCircle className="w-5 h-5 text-red-500" />
      <p className="text-red-700">{message}</p>
    </div>
  );
};

export default ErrorAlert;